
import React, { Component } from 'react';
import Row from '../Row';
import Col from '../Col';
import Form from '../Form';
import Button from '../Button';
import { toast } from 'react-toastify';
import Loader from '../Loader/Loader';
import * as markerjs2 from 'markerjs2';

class AnnotationImage extends Component {
  state = {
    index: 0,
    image: {},
    images: [],
    loader: false,
    showMarker: false
  }

  async componentDidMount() {
    const { images } = this.props;    
    const annotateImages = images.filter(item => item.url)
    let index = images.findIndex(x => x.url);    
    this.setState({
      images: images,
      image: annotateImages[0],
      isLoading: false,
      index: index
    })
  }

  invokeMarkers = () => {
    let markerArea = new markerjs2.MarkerArea(document.getElementById('imageToAnnotate'));
    markerArea.addRenderEventListener(dataUrl => {
      this.setAnnotatedImages(dataUrl)
    });
    markerArea.show();
    markerArea.addCloseEventListener(() => {
      this.setState({ showMarker: false })
    })
  }
  setAnnotatedImages = async (uri) => {
    try {
    let { images, image, index} = this.state;
    images = images.map((data, i) => {
      if(data.url) {
        if (i === index) {
          return {...data, url: uri}
        } else {
          return data
        }
      } else {
        return data
      }
    })
    this.setState({ image: {...image, url: uri}, images: images, showMarker: false });
    toast.success('Annotation image has been saved.', { autoClose: 1000, position: 'top-center' });
    localStorage.setItem('isAnnotationImageUpload',true);
  }
  catch(error){
    toast.error('There seems to be some problem with the low memory, unable to process the request now.', { autoClose: 1000,position:'top-center' });
   return false;
  }
  }

  showMarkerJs = () => {
    this.setState({ showMarker: true })
    this.invokeMarkers();
  }

  hideMarkers = (type) => {
    if (type === false) {
    } else {
      this.setState({ showMarker: false })
    }
    var test = document.getElementsByClassName('__markerjs2_');
    for (var i = 0; i < test.length; i++) {
      test[i].style.display = "none";
    }
  }
  render() {
    const { onClose, onSaveImagesAnotated } = this.props;
    const { image, images, loader, showMarker } = this.state;
    
    return (

      <Form
        headline={'Annotate Image'}
        onClose={() => { this.hideMarkers(); onClose() }}
        actions={(
          <>
            {loader && <Loader center={true} />}
            <div />
            <Button
              color="complete_purple"
              size="small"
              label="Done"
              onClick={() => { this.hideMarkers(); onSaveImagesAnotated(images) }}
              disabled={false}
            />
          </>
        )}
        component={(
          <Row mdCenter>
            <Col
              xs="12"
              md="6"
            >
              <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>

                <div style={{ marginTop: 40 }}>
                  <img id='imageToAnnotate' style={{ width: '350px', height: 'auto', margin: '0 auto !important', display: 'block' }}
                    src={image.url} onClick={() => this.showMarkerJs()} />
                </div>
                <div style={{ paddingTop: 10 }}>
                  Note: Tap the image to annotate.
              </div>
                {
                  images.length > 1 &&
                    <div style={{ display: 'flex', paddingTop: 40 }}>
                      {images.filter(item => item.url).map((data, index) => {
                        if(data && data.url) {
                        return (
                          <div style={{ padding: 10, borderStyle: this.state.index === index ? 'dotted' : "none" }} 
                          onClick={() => { this.setState({ image: data, index: index }); this.hideMarkers(false); }}>
                           <img src={data.url} height='50' width='50' />
                         </div>
                        )
                      }
                      })}
                    </div>
                }
              </div>
            </Col>
          </Row>
        )}
      />

    )
  }
}



export default AnnotationImage;

